document.addEventListener('DOMContentLoaded', function() {
	$("#busca_servicio").selectize({
		create: false,
    	sortField: 'text'
    });

    $("#busca_alcaldia").selectize({
		create: false,
    	sortField: 'text',
    	plugins: ['remove_button']
    });
});